import type { CartSimulationEntry, CartSimulationRequest, CartSimulationResponseItem } from "~/domains/cart/types";
import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";

type SimulationResponseDTO = {
  results?: CartSimulationResponseItem[];
  quantityAdjusted: boolean;
};

/**
 * Simulates an add-to-cart attempt without requiring or creating an Active Cart.
 *
 * The simulation resource is cart-independent, so a phase-out preview on a product page never
 * persists an empty Cart for a visitor who has not added anything yet.
 */
export async function simulateCart(entries: CartSimulationEntry[], signal?: AbortSignal) {
  const body: CartSimulationRequest = {
    items: entries,
  };

  const response = await occFetch(occBaseSiteUrl(`${occCartUserPath()}/add-to-cart/simulation`), {
    body: JSON.stringify(body),
    headers: {
      "content-type": "application/json",
    },
    method: "POST",
    signal,
  });

  if (!response.ok) {
    throw new Error(`Cart simulate failed with status ${response.status}`);
  }

  const dto = (await response.json()) as SimulationResponseDTO;
  return {
    ...dto,
    results: dto.results ?? [],
  };
}
